export const roadToDieFinalsRugby7sQualifikation2026 = {
  "id": "road-to-die-finals-rugby-7s-qualifikation-2026",
  "title": "UPDATE: Road to DIE FINALS: Der Kampf um die letzten Tickets zur Deutschen Rugby 7er Meisterschaft",
  "slug": "road-to-die-finals-rugby-7s-qualifikation-2026",
  "publishedAt": "2026-02-24T10:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "9 min",
  "tags": [
    "Rugby",
    "7er Rugby",
    "Deutsche Meisterschaft",
    "DIE Finals",
    "Qualifikation",
    "Berlin",
    "München"
  ],
  "excerpt": "Zwanzig Teams kämpfen um die letzten vier Startplätze für DIE FINALS der Deutschen Rugby 7er Meisterschaft. In Berlin und München entscheidet sich am 27. Juni, wer den Sprung in die Endrunde schafft.",
  "img": "/images/road-to-die-finals-rugby-7s-qualifikation-2026.jpg",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Der Weg zur Deutschen Rugby 7er Meisterschaft der Herren, ist definiert. Zwanzig Teams haben für den Wettbewerb gemeldet. Und damit deutlich mehr als im Vorjahr. Fünf Mannschaften sind bereits gesetzt. Fünfzehn Teams kämpfen damit um die letzten vier Startplätze für DIE FINALS. Zwei Städte werden zu Schauplätzen dieser Entscheidung. Berlin im Norden. München im Süden. Ein Tag. Vier Tickets. Und für viele Teams die vielleicht wichtigste Etappe der 7er Saison."
    },
    {
      "type": "paragraph",
      "content": "In der RBA Sitzung am 13. Juni 2026 wird über eine mögliche Neuausrichtung des Qualifikationsmodus entschieden. Zudem erfolgt an diesem Tag auch die Gruppenauslosung für DIE FINALS. Die Endrundengruppen stehen somit fest noch bevor die Qualifikationsturniere beendet sind."
    },
    {
      "type": "paragraph",
      "content": "Die sportliche Ausgangslage ist klar definiert. Als Titelverteidiger steht der SC Germania List bereits in der Endrunde. Begleitet wird er von der RG Heidelberg als Vizemeister, Hannover 78 als Drittplatziertem der Vorsaison, dem Berliner SV 1892 als Viertplatziertem sowie dem TSV Handschuhsheim als Fünftem des vergangenen Jahres. Diese fünf Teams beobachten die Qualifikation aus der Pole Position. Vier weitere Herausforderer werden sich am 27. Juni dazugesellen."
    },
    {
      "type": "paragraph",
      "content": "Die Besetzung der Qualifikationsturniere sowie die Auslosung der Gruppen erfolgte am 23.02. im Rahmen der RBA Vorstandssitzung."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Qualifikationsturnier in Berlin"
    },
    {
      "type": "paragraph",
      "content": "Acht Teams treten im Nordturnier in Berlin an und spielen zwei Endrundentickets für DIE FINALS aus. Ab 10:00 Uhr empfängt Gastgeber RK 03 Berlin die Konkurrenz in der Buschallee, wo ein intensiver Turniertag mit hoher Spielgeschwindigkeit und körperbetonten Begegnungen zu erwarten ist. Das Teilnehmerfeld ist breit aufgestellt und vereint traditionsreiche Standorte mit ambitionierten Herausforderern, die den Sprung in die Endrunde erzwingen wollen. Die Auslosung strukturierte das Turnier in zwei ausgeglichene Vierergruppen, wodurch sich bereits in der Vorrunde direkte Schlüsselspiele ergeben. Kleine Fehler können unmittelbare Auswirkungen auf den Tabellenverlauf haben, während konsequent genutzte Chancen früh die Weichen Richtung Halbfinale und damit Richtung Endrundenticket stellen können."
    },
    {
      "type": "paragraph",
      "content": "In Gruppe A finden sich:"
    },
    {
      "type": "list",
      "items": [
        "RK 03 Berlin",
        "Berliner RC",
        "Victoria Linden",
        "Rugby Ricklingen"
      ]
    },
    {
      "type": "paragraph",
      "content": "Gruppe B besteht aus:"
    },
    {
      "type": "list",
      "items": [
        "FC St. Pauli Rugby",
        "RC Leipzig",
        "Wiedenbrücker TV",
        "SC Frankfurt 1880"
      ]
    },
    {
      "type": "paragraph",
      "content": "Im Sinne einer möglichst ausgewogenen Turnierstruktur zwischen Nord und Süd, sowie zur Reduzierung des Reiseaufwandes wurden der Wiedenbrücker TV und SC Frankfurt 1880 dem Nordturnier zugeordnet."
    },
    {
      "type": "heading",
      "level": 3,
      "content": "Spielplan Berlin"
    },
    {
      "type": "paragraph",
      "content": "Gruppe A"
    },
    {
      "type": "list",
      "items": [
        "10:00 bis 10:20 RK 03 Berlin gegen Berliner RC",
        "10:20 bis 10:40 Rugby Ricklingen gegen Victoria Linden"
      ]
    },
    {
      "type": "paragraph",
      "content": "Gruppe B"
    },
    {
      "type": "list",
      "items": [
        "10:40 bis 11:00 FC St. Pauli gegen RC Leipzig",
        "11:00 bis 11:20 SC Frankfurt 1880 gegen Wiedenbrücker TV"
      ]
    },
    {
      "type": "paragraph",
      "content": "11:20 bis 12:00 Pause"
    },
    {
      "type": "paragraph",
      "content": "Gruppe A"
    },
    {
      "type": "list",
      "items": [
        "12:00 bis 12:20 Victoria Linden gegen RK 03 Berlin",
        "12:20 bis 12:40 Berliner RC gegen Rugby Ricklingen"
      ]
    },
    {
      "type": "paragraph",
      "content": "Gruppe B"
    },
    {
      "type": "list",
      "items": [
        "12:40 bis 13:00 RC Leipzig gegen SC Frankfurt 1880",
        "13:00 bis 13:20 Wiedenbrücker TV gegen FC St. Pauli"
      ]
    },
    {
      "type": "paragraph",
      "content": "13:20 bis 14:00 Pause"
    },
    {
      "type": "paragraph",
      "content": "Gruppe A"
    },
    {
      "type": "list",
      "items": [
        "14:00 bis 14:20 Berliner RC gegen Victoria Linden",
        "14:20 bis 14:40 Rugby Ricklingen gegen RK 03 Berlin"
      ]
    },
    {
      "type": "paragraph",
      "content": "Gruppe B"
    },
    {
      "type": "list",
      "items": [
        "14:40 bis 15:00 SC Frankfurt 1880 gegen FC St. Pauli",
        "15:00 bis 15:20 RC Leipzig gegen Wiedenbrücker TV"
      ]
    },
    {
      "type": "paragraph",
      "content": "15:20 bis 16:40 Pause"
    },
    {
      "type": "list",
      "items": [
        "16:40 bis 17:00 Platzierungsfinale Sieger Gruppe A gegen Zweiter Gruppe B – DIE FINALS Qualifikant 1",
        "17:00 bis 17:20 Platzierungsfinale Sieger Gruppe B gegen Zweiter Gruppe A – DIE FINALS Qualifikant 2"
      ]
    },
    {
      "type": "paragraph",
      "content": "Die Sieger dieser beiden Finalspiele lösen die Nordtickets für DIE FINALS. Der Weg dorthin führt über Tempo, Präzision und mentale Stabilität. Im Siebener Rugby entscheiden oft Sekunden."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Qualifikationsturnier München"
    },
    {
      "type": "paragraph",
      "content": "Acht Teams gehen im Südturnier an den Start und bilden damit ein kompaktes, zugleich hoch kompetitives Teilnehmerfeld, in dem zwei Endrundenplätze vergeben werden. Austragungsort ist die Anlage des München RFC in der Ludwig Hunger Straße, wo sich die süddeutschen und westdeutschen Vertreter zum direkten Vergleich treffen. Gespielt wird 2 Gruppen mit 4 Mannschaften. Es gilt in drei Spielen den Platz für das Qualifikationsfinale zu erspielen."
    },
    {
      "type": "paragraph",
      "content": "In Gruppe A finden sich:"
    },
    {
      "type": "list",
      "items": [
        "München RFC",
        "Heidelberger RK",
        "RC Aachen",
        "StuSta Rugby München"
      ]
    },
    {
      "type": "paragraph",
      "content": "Gruppe B besteht aus:"
    },
    {
      "type": "list",
      "items": [
        "RSV Köln",
        "RC Walferdange",
        "RK Heusenstamm",
        "RC Unterföhring"
      ]
    },
    {
      "type": "heading",
      "level": 3,
      "content": "Spielplan München"
    },
    {
      "type": "paragraph",
      "content": "Gruppe A"
    },
    {
      "type": "list",
      "items": [
        "10:00 bis 10:20 StuSta München gegen München RFC",
        "10:20 bis 10:40 RC Aachen gegen Heidelberger RK"
      ]
    },
    {
      "type": "paragraph",
      "content": "Gruppe B"
    },
    {
      "type": "list",
      "items": [
        "10:40 bis 11:00 RC Unterföhring gegen RK Heusenstamm",
        "11:00 bis 11:20 RSV Köln gegen RC Walferdange"
      ]
    },
    {
      "type": "paragraph",
      "content": "11:20 bis 12:00 Pause"
    },
    {
      "type": "paragraph",
      "content": "Gruppe A"
    },
    {
      "type": "list",
      "items": [
        "12:00 bis 12:20 Heidelberger RK gegen Stusta München",
        "12:20 bis 12:40 München RFC gegen RC Aachen"
      ]
    },
    {
      "type": "paragraph",
      "content": "Gruppe B"
    },
    {
      "type": "list",
      "items": [
        "12:40 bis 13:00 RK Heusenstamm gegen RSV Köln",
        "13:00 bis 13:20 RC Walferdange gegen RC Unterföhring"
      ]
    },
    {
      "type": "paragraph",
      "content": "13:20 bis 14:00 Pause"
    },
    {
      "type": "paragraph",
      "content": "Gruppe A"
    },
    {
      "type": "list",
      "items": [
        "14:00 bis 14:20 RC München RFC gegen Heidelberger RK",
        "14:20 bis 14:40 RC Aachen gegen StuSta München"
      ]
    },
    {
      "type": "paragraph",
      "content": "Gruppe B"
    },
    {
      "type": "list",
      "items": [
        "14:40 bis 15:00 RC Unterföhring gegen RSV Köln",
        "15:00 bis 15:20 RK Heusenstamm gegen RC Walferdange"
      ]
    },
    {
      "type": "paragraph",
      "content": "15:20 bis 16:40 Pause"
    },
    {
      "type": "list",
      "items": [
        "16:40 bis 17:00 Platzierungsfinale Sieger Gruppe A gegen Zweiter Gruppe B – DIE FINALS Qualifikant 3",
        "17:00 bis 17:20 Platzierungsfinale Sieger Gruppe B gegen Zweiter Gruppe A – DIE FINALS Qualifikant 4"
      ]
    },
    {
      "type": "paragraph",
      "content": "Auch hier sichern sich nur die Sieger der Finalspiele den Einzug in DIE FINALS. Für alle anderen endet der Traum an diesem Tag."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Mehr als nur Qualifikation"
    },
    {
      "type": "paragraph",
      "content": "Beide Turniere werden vollständig im Liveticker abgebildet. Zusätzlich stellen die Ausrichter Livestreams bereit. Die entsprechenden Zugänge werden kurz vor Turnierbeginn veröffentlicht. Fans, Vereine und Beobachter können somit jede Entwicklung in Echtzeit verfolgen."
    },
    {
      "type": "paragraph",
      "content": "Die Ausgangslage ist eindeutig. Fünf Teams warten bereits. Fünfzehn kämpfen. Vier werden bestehen. Wenn am Abend des 27. Juni die letzten Entscheidungen fallen, wird das Teilnehmerfeld für DIE FINALS komplett sein. Der Weg dorthin führt über Berlin und München. Über Geschwindigkeit. Über Mut. Und über den unbedingten Willen, Teil der Deutschen Rugby 7er Meisterschaft zu werden."
    }
  ]
};
